import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import InputField from '../../../components/inputs/inputField';
import BasicSectionHeader from '../../../components/views/BasicSectionHeader';

class RequestDetails extends Component {
	render() {
		const { request, event } = this.props;
		return (
			<div className="sectionContainer">
				<BasicSectionHeader
					title={'Program Request Details'}
					description={`${request.status == 'pending'
						? 'Request is pending, approve it to create event'
						: request.status == 'denied' ? 'Request was denied' : 'Request was approved'}`}
					mainActions={[
						{ type: 'link', label: 'View program', target: `/admin/programs/${request.programId}/0` }
					]}
					breadcrumbs={[
						{
							name: 'Events',
							link: `/admin/events`
						},
						{
							name: event.name,
							link: `/admin/events/${event._id}/0`
						}
					]}
				/>
				<div className="sectionBody pt-0">
					<div className="sectionBlock">
						<div className="sectionSubtitle">Request Details</div>
						<InputField
							label="Submitter Name"
							value={request.submitterName}
							disabled={true}
							inputIcon={<i className="las la-lock" />}
						/>
						<InputField
							label="Submitter Email"
							value={request.submitterEmail}
							disabled={true}
							inputIcon={<i className="las la-lock" />}
						/>
						<InputField
							label="Requested Event Name"
							value={request.name}
							disabled={true}
							inputIcon={<i className="las la-lock" />}
						/>
						<div className="flex-sb w-100">
							<InputField
								label="Start Date"
								type="date"
								value={request.startDate}
								classes="mr-10"
								disabled={true}
								inputIcon={<i className="las la-lock" />}
							/>
							<InputField
								label="End Date"
								type="date"
								classes="ml-10"
								value={request.endDate}
								disabled={true}
								inputIcon={<i className="las la-lock" />}
							/>
						</div>
						<div className="flex-sb w-100">
							<InputField
								label="Start Time"
								type="time"
								classes="mr-10"
								value={request.startTime}
								disabled={true}
								inputIcon={<i className="las la-lock" />}
							/>
							<InputField
								label="End Time"
								type="time"
								classes="ml-10"
								value={request.endTime}
								disabled={true}
								inputIcon={<i className="las la-lock" />}
							/>
						</div>
						{request.fieldLabels &&
							Object.keys(request.fieldLabels).map((field, i) => {
								if (request[field] && request[field] != '')
									return (
										<InputField
											label={request.fieldLabels[field]}
											type="text"
											value={request[field]}
											disabled={true}
											inputIcon={<i className="las la-lock" />}
										/>
									);
							})}
					</div>
				</div>
			</div>
		);
	}
}

export default withRouter(RequestDetails);
